export default {
  background: {
    signin_bg_image: 'https://fishsale.jp/assets/signin-bg-image.jpg',
    top_hero_pc: 'https://fishsale.jp/assets/hero-top-pc.jpg',
    top_hero_mobile: 'https://fishsale.jp/assets/hero_top_mobile.jpg',
  },
  logo: {
    twitter:
      'https://fishsale.jp/assets/Twitter_Social_Icon_Rounded_Square_Color.png',
    line: 'https://fishsale.jp/assets/LINE_Icon.png',
    facebook: 'https://fishsale.jp/assets/FB-f-Logo__blue_50.png',
  },
  icon: {
    social: {},
    mail: 'https://fishsale.jp/assets/mail.png',
    arrow_left: 'https://fishsale.jp/assets/arrow-left.svg',
    arrow_right: 'https://fishsale.jp/assets/arrow-right.svg',
  },
  creditCard: {
    security:
      'https://fishsale.jp/assets/b8017c7ee623fb4ad63f2b35d1855dee1.png',
  },
};
